export default "__VITE_ASSET__0e4c26b1__"